/** What the grid-region control's value can mean, and how a region reads in its list.
 *
 * Apart from the component so the add form and the correction form can share them without a
 * component file exporting plain values (which breaks fast refresh).
 */

import type { GridRegion } from "../api/gridRegions";

/** Sentinel for "the customer said they do not know", distinct from "has not looked yet" (`""`). */
export const GRID_UNKNOWN = "__unknown__";

/** How a region reads in the list: the code and the publisher's own name beside it. */
export function regionLabel(region: GridRegion): string {
  return region.name ? `${region.code} - ${region.name}` : region.code;
}
